// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"6e6fda44","112":"600ade4e","258":"8e8ed9a0","377":"8d0a6d27","417":"12e8f031","467":"0f0e3448","626":"d480170c","870":"b9866701"}[chunkId] + ".js";
};